import { Moon, Sun, Monitor, Zap, ZapOff } from 'lucide-react'
import { useTheme } from '../contexts/ThemeContext'

export function ThemeToggle() {
  const { theme, setTheme, resolvedTheme, reduceMotion, setReduceMotion } = useTheme()

  const toggleTheme = () => {
    if (theme === 'light') {
      setTheme('dark')
    } else if (theme === 'dark') {
      setTheme('system')
    } else {
      setTheme('light')
    }
  }

  const getIcon = () => {
    if (theme === 'system') {
      return <Monitor className="w-4 h-4" />
    }
    return resolvedTheme === 'dark' ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />
  }

  const getLabel = () => {
    if (theme === 'system') return 'System'
    return resolvedTheme === 'dark' ? 'Dark' : 'Light'
  }

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={toggleTheme}
        className="px-3 py-2 rounded-lg border-2 border-[#bcccdc] dark:border-[#3E5365] bg-white dark:bg-[#2A3B4C] text-[#102a43] dark:text-[#E8E9E9] hover:bg-[#f0f4f8] dark:hover:bg-[#3E5365] transition-colors flex items-center gap-2"
        title={`Current theme: ${getLabel()}. Click to toggle.`}
        aria-label={`Theme: ${getLabel()}. Activate to change theme.`}
      >
        <span aria-hidden="true">{getIcon()}</span>
        <span className="text-sm hidden sm:inline">{getLabel()}</span>
      </button>
      <button
        onClick={() => setReduceMotion(!reduceMotion)}
        className="px-3 py-2 rounded-lg border-2 border-[#bcccdc] dark:border-[#3E5365] bg-white dark:bg-[#2A3B4C] text-[#102a43] dark:text-[#E8E9E9] hover:bg-[#f0f4f8] dark:hover:bg-[#3E5365] transition-colors flex items-center gap-2"
        title={reduceMotion ? 'Animations reduced. Click to enable animations.' : 'Animations on. Click to reduce motion.'}
        aria-label={reduceMotion ? 'Reduce motion is on. Activate to enable animations.' : 'Reduce motion is off. Activate to reduce motion.'}
        aria-pressed={reduceMotion}
      >
        <span aria-hidden="true">{reduceMotion ? <ZapOff className="w-4 h-4" /> : <Zap className="w-4 h-4" />}</span>
        <span className="text-sm hidden sm:inline">{reduceMotion ? 'Reduced' : 'Motion'}</span>
      </button>
    </div>
  )
}

